import { ApiRoutes } from "../common/apiRoutes";
import Http from "../services/http";

export const getCustomersAPI = (search:any,page:any,limit:any,selectedStatus:any,sortField:any,sortDirection:any) => {
  return Http.get(`customer?search=${search}&page=${page}&limit=${limit}&status=${selectedStatus}&sort_by=${sortField}&sort_direction=${sortDirection}`);
};

export const addCustomerAPI = (data:any) => {
  return Http.post(ApiRoutes.addCustomer,data);
};
export const getCustomersDetailsAPI = (id:any) => {
  return Http.get(`customer/${id}`);
};
export const deleteCustomerAPI = (id:any) => {
  return Http.delete(`customer/${id}`);
};
export const editCustomerAPI = (id:any,data:any) => {
  return Http.put(`customer/${id}`,data);
};

export const getBookingIdAPI = (search:any,page:any,limit:any,sort_by:any,sort_direction:any,start_date:any,end_date:any,selectedStatus:any,id:any) => {
  // return Http.get(`booking?page=${page}&search=${search}&limit=${limit}&sort_by=${sort_by}&sort_direction=${sort_direction}&start_date=${start_date}&end_date=${end_date}&status=${selectedStatus}&customer_id=${id}`);
  return Http.get(`booking?page=${page}&search=${search}&limit=${limit}&sort_by=${sort_by}&sort_direction=${sort_direction}&start_date=${start_date}&end_date=${end_date}&status=${selectedStatus}&customer_id=${id}`);
};
export const getBookingIdDetailsAPI = (id:any) => {
  return Http.get(`booking/${id}`);
};

export const transactionAPI = (search:any,page:any,limit:any,sort_by:any,sort_direction:any,start_date:any,end_date:any)=>{
  return Http.get(`transaction?page=${page}&search=${search}&limit=${limit}&sort_by=${sort_by}&sort_direction=${sort_direction}&startDate=${start_date}&endDate=${end_date}`);
}

export const transactionDetailAPI = (id:any) => {
  return Http.get(`transaction/${id}`);
};

export const getUpdateStatusAPI = (id:any,data: any) => {
  return Http.put(`booking/${id}`, data);
};

export const allCustomerAPI = () => {
  return Http.get("customer/list");
};